import React, { useState, useEffect } from 'react';
import { Type, Hash, AlignLeft } from 'lucide-react';
import Header from './components/Header';
import StatBox from './components/StatBox';
import DetailRow from './components/DetailRow';
import { calculateStats, getReadingTime, getAverageCharsPerWord } from './utils/textStats';
import './styles/global.css';

const WordCounter = () => {
  const [text, setText] = useState('');
  const [stats, setStats] = useState({
    words: 0,
    characters: 0,
    charactersNoSpaces: 0,
    lines: 0,
    sentences: 0,
    paragraphs: 0
  });

  useEffect(() => {
    const newStats = calculateStats(text);
    setStats(newStats);
  }, [text]);

  const clearText = () => {
    setText('');
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      padding: '40px 20px',
      fontFamily: '"Press Start 2P", monospace'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <Header onClear={clearText} hasText={text.length > 0} />

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 400px',
          gap: '24px'
        }}>
          {/* Text Area */}
          <div style={{
            background: 'white',
            border: '5px solid #d53369',
            boxShadow: '12px 12px 0px rgba(0,0,0,0.4)',
            overflow: 'hidden'
          }}>
            <textarea
              value={text}
              onChange={handleTextChange}
              placeholder="Escribe o pega tu texto aqui..."
              style={{
                width: '100%',
                minHeight: '500px',
                padding: '24px',
                border: 'none',
                resize: 'none',
                fontSize: '12px',
                lineHeight: '2',
                fontFamily: 'monospace',
                color: '#2d3748',
                background: '#f7fafc',
                outline: 'none'
              }}
              rows={20}
            />
          </div>

          {/* Stats Panel */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {/* Main Stats */}
            <div style={{
              background: 'white',
              border: '5px solid #d53369',
              boxShadow: '12px 12px 0px rgba(0,0,0,0.4)',
              padding: '24px'
            }}>
              <h2 style={{
                fontSize: '12px',
                color: '#d53369',
                marginBottom: '20px',
                letterSpacing: '1px'
              }}>
                ESTADISTICAS
              </h2>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <StatBox
                  icon={<Type size={16} />}
                  label="PALABRAS"
                  value={stats.words}
                  color="#805ad5"
                />
                <StatBox
                  icon={<Hash size={16} />}
                  label="CARACTERES"
                  value={stats.characters}
                  color="#d53f8c"
                />
                <StatBox
                  icon={<Hash size={16} />}
                  label="SIN ESPACIOS"
                  value={stats.charactersNoSpaces}
                  color="#dd6b20"
                />
                <StatBox
                  icon={<AlignLeft size={16} />}
                  label="LINEAS"
                  value={stats.lines}
                  color="#3182ce"
                />
              </div>
            </div>

            {/* Additional Stats */}
            <div style={{
              background: 'white',
              border: '5px solid #d53369',
              boxShadow: '12px 12px 0px rgba(0,0,0,0.4)',
              padding: '24px'
            }}>
              <h2 style={{
                fontSize: '12px',
                color: '#d53369',
                marginBottom: '20px',
                letterSpacing: '1px'
              }}>
                DETALLES
              </h2>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <DetailRow label="Oraciones" value={stats.sentences} />
                <DetailRow label="Parrafos" value={stats.paragraphs} />
                <DetailRow label="Lectura" value={`${getReadingTime(stats.words)} min`} />
                <DetailRow 
                  label="Promedio" 
                  value={`${getAverageCharsPerWord(stats.characters, stats.words)} car/pal`}
                />
              </div>
            </div>

            {/* Info Box */}
            <div style={{
              background: '#fef5e7',
              border: '4px solid #f39c12',
              padding: '16px',
              fontSize: '8px',
              lineHeight: '1.8',
              color: '#7d6608',
              boxShadow: '8px 8px 0px rgba(0,0,0,0.2)'
            }}>
              <strong>INFO:</strong> Las estadísticas se actualizan en tiempo real mientras escribes. El tiempo de lectura está basado en 200 palabras por minuto.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WordCounter;